<template>
  <div
    class="flex items-center justify-between px-4 py-1 mb-2 ml-2 text-sm text-gray-400 bg-white rounded-full min-w-max"
    v-for="(data, index) in markedDatas"
    :key="index"
  >
    {{ data.company_name }}
    <font-awesome-icon
      icon="fa-xmark"
      class="ml-2 cursor-pointer"
      @click="$emit('on-remove-data', data)"
    />
  </div>
</template>

<script>
export default {
  name: "ListMarkedData",
  props: {
    markedDatas: {
      type: Array,
      required: true,
    },
  },
};
</script>
